import type { Order } from '@trmediaab/zebra-types/trhub';
import { useEffect } from 'react';
import useSWR from 'swr';

import ProgressBar from '../../components/ProgressBar';
import { setError, setOrder } from '../../state';
import type { ErrorWithMessage } from '../../types/ErrorWithMessage';
import { ensureErrorWithMessage } from '../../utils/ensureErrorWithMessage';

interface CampaignProps {
  campaign: string;
  onNext: () => void;
}

const CampaignView = ({ campaign, onNext }: CampaignProps) => {
  const { data, error } = useSWR<Order, ErrorWithMessage>(
    `order/campaign/${campaign}`,
  );

  useEffect(() => {
    if (error != null) {
      setError(ensureErrorWithMessage(error));
    } else if (data != null) {
      setOrder(data);
      onNext();
    }
  }, [campaign, data, error, onNext]);

  return <ProgressBar progress={25} />;
};

export default CampaignView;
